import React from 'react';
import SpinnerLoader from '../../SpinnerLoader/SpinnerLoader';
import ImageWrapper from '../../ImageWrapper/ImageWrapper';
import warningIcon from './images/error.png';
import './Tab.css';

function Tab({id, title, selected, isLoading, loaded, onClick}) {
    const handleClick = () => {
        if (onClick) onClick(id);
    };

    const tabStyle = () => {
        return {
            color: selected ? '#002EFF' : '#909090',
            borderBottom: `solid 3px ${selected ? '#FF3D00' : '#FFFFFF'}`
        };
    };

    return (
        <div className='tab' onClick={handleClick} style={tabStyle()}>
            {title}
            {isLoading && (
                <div className='tab_loader'>
                    <SpinnerLoader size={15} color='#ACACAC'/>
                </div>
            )}
            {!isLoading && !loaded && (
                <div className='tab_error'>
                    <ImageWrapper
                        image={warningIcon}
                        alt='Warning'
                        display='block'
                        width={18}
                        height='auto'
                        errorWidth={undefined}
                        errorHeight={undefined}
                        errorPadding={undefined}
                        margin={0}
                        borderRadius={0}
                        transition={true}
                        loadDelay={0.1}
                        onLoad={undefined}
                        onMouseEnter={undefined}
                        onMouseLeave={undefined}
                    />
                </div>
            )}
        </div>
    );
}

export default Tab;